import { remove, get } from 'lodash';

import PureGameElement        from '../../tools/PureGameElement';
import { getRandomInt }       from '../../tools/functions';
import {
    animalsAssets,
    defaultLoadAnimalAssetConfig,
    defaultAnimAnimalAssetConfig
}                             from '../../constants/animalAssets';
import { diffBaseSpawnDelay } from '../../constants/appConstants';
import Animal                 from '../Animal/Animal';
import { animalAudio }        from '../../constants/audioConstants';

class SpawnManager extends PureGameElement {
    constructor ( scene ) {
        super( scene );
        this.spanwItem = [];
        this._spawnEvent = null;
    }

    get spawnDelay () {
        return diffBaseSpawnDelay / this.scene.difficulty;
    }

    preload () {
        super.preload();
        this.scene.load.audio( animalAudio.key, animalAudio.source );
        this.scene.sound.add( animalAudio.key, animalAudio.data ); //TODO: --> ça dans create()
        animalsAssets.forEach( animalAsset => {
            this.scene.load.spritesheet( animalAsset.spriteId, animalAsset.sprite, {
                ...defaultLoadAnimalAssetConfig,
                ...get( animalAsset, 'loadSpriteConfig', {} ),
            } );
        } );

    }

    create () {
        super.create();
        animalsAssets.forEach( animalAsset => {
            this.scene.anims.create( {
                ...defaultAnimAnimalAssetConfig,
                ...get( animalAsset, 'createAnimConfig', {} ),
                key: animalAsset.animId,
                frames: this.scene.anims.generateFrameNumbers( animalAsset.spriteId ),
            } );
        } );


        this._spawnEvent = this.scene.time.addEvent( {
            delay: this.spawnDelay,
            callback: this.spawn,
            callbackScope: this,
            loop: true
        } );
    }

    update () {
        super.update();
        this.spanwItem.forEach( animal => animal.update() );
    }

    onDifficultyUpdate ( newDifficulty ) {
        this._spawnEvent.delay = this.spawnDelay;
        this.spanwItem.forEach( animal => animal.onDifficultyUpdate( newDifficulty ) );
    }


    getSpawnRails () {
        // if ( getRandomInt( 0, 2 / ( this.scene.difficulty ) ) !== 0 )
        //     return null;
        const railIndex = getRandomInt( 0, this.scene.rails.length - 1 );
        return this.scene.rails[railIndex];
    }

    getRandomAnimalConf () {
        const animalsAssetsFiltered = animalsAssets.filter( x => x.active );
        const animalIndex = getRandomInt( 0, animalsAssetsFiltered.length - 1 );
        return animalsAssetsFiltered[animalIndex];
    }

    spawn () {
        const selectedRail = this.getSpawnRails();
        if ( selectedRail ) {
            const newAnimal = new Animal(
                this.scene,
                selectedRail,
                this.getRandomAnimalConf()
            );
            newAnimal.create();
            this.spanwItem.push( newAnimal );
        }
    }

    destroyAnimal ( animal ) {
        remove( this.spanwItem, a => a === animal );
    }

}

export default SpawnManager;
